import * as SdkConfig from 'rev.sdk.js/Config';
import * as Config from '../data.json';

SdkConfig.init(Config);
